import { render, staticRenderFns } from "./particulars1.vue?vue&type=template&id=becd2266&scoped=true"
import script from "./particulars1.vue?vue&type=script&lang=js"
export * from "./particulars1.vue?vue&type=script&lang=js"
import style0 from "./particulars1.vue?vue&type=style&index=0&id=becd2266&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "becd2266",
  null
  
)

export default component.exports